import paragraph_icon from '../assets/paragraph_icon.png';
import word_count_icon from '../assets/word_count_icon.png';
import microphone_icon from '../assets/microphone_icon_yellow.png';
import chapter_1_mockup from '../assets/born_in_1946_mockup.png';
import chapter_2_mockup from '../assets/year_in_america_mockup.png';
import chapter_3_mockup from '../assets/summer_haven_mockup.png';
import chapter_1_image_preview from '../assets/frogs_in_bag_image_preview.png';
import chapter_2_image_preview from '../assets/year_in_america_image_preview.png';
import chapter_3_image_preview from '../assets/summer_haven_image_preview.png';
import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AudioPlayer from './AudioPlayer';
import listen_icon from '../assets/listen_icon.png';
import arrow from '../assets/yellow_arrow.png';

export default function Samples(props) {
    const [expandedChapterIndex, setExpandedChapterIndex] = useState(0);
    const [audioPlayerForChapterOpen, setAudioPlayerForChapterOpen] = useState(-1);
    
    const chapters = [
        {
            "id": 1,
            "title": "Chapter 1",
            "subtitle": "Born in 1946",
            "wordCount": "4,923 words",
            "interviewLength": "61 min interview"
        },
        {
            "id": 2,
            "title": "Chapter 2",
            "subtitle": "A Year in America",
            "wordCount": "4,746 words",
            "interviewLength": "72 min interview"
        },
        {
            "id": 3,
            "title": "Chapter 3",
            "subtitle": "A Summer Haven",
            "wordCount": "7,133 words",
            "interviewLength": "52 min interview"
        },
    ]

    // Define handleScroll with useCallback to prevent infinite re-renders
    const handleScroll = useCallback(() => {
        const viewportHeight = window.innerHeight;

        const chapterExpandedElements = document.querySelectorAll('.chapter-sample-expanded');
        const chapterNonExpandedElements = document.querySelectorAll('.chapter-sample');
        const chapterElements = [...chapterExpandedElements, ...chapterNonExpandedElements];
        chapterElements.sort((a, b) => {
            return a.id.localeCompare(b.id);
        });

        chapterElements.forEach((chapterElement, index) => {
            const chapterElementTop = chapterElement.getBoundingClientRect().top;
            const chapterElementHeight = chapterElement.getBoundingClientRect().height;
            const chapterElementBottomRelative = chapterElementTop + chapterElementHeight - viewportHeight;
            
            if (chapterElementBottomRelative < 0) {
                setExpandedChapterIndex(index);   
            }
        });
    }, [expandedChapterIndex]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    

    function getSampleChapter(chapterDetails, isExpanded) {
        let mockup_img = chapter_1_mockup
        let chapter_image_preview = chapter_1_image_preview
        let pdf_url = `/pdfs/frogs_in_bag.pdf`
        if (chapterDetails.id === 2) {
            mockup_img = chapter_2_mockup
            chapter_image_preview = chapter_2_image_preview
            pdf_url = `/pdfs/year_in_america.pdf`
        } else if (chapterDetails.id === 3) {
            mockup_img = chapter_3_mockup
            chapter_image_preview = chapter_3_image_preview
            pdf_url = `/pdfs/summer_haven.pdf`
        }
        const expandedElem = (
            <motion.div
                key="expanded"
                initial={{ width: 0 }}
                animate={{ width: '100%' }}
                exit={{ width: 0, transition: { duration: 0 }}}
                transition={{ duration: 0.2 }}
                style={{
                    transformOrigin: 'top left', 
                    display: 'flex', 
                    flexDirection: 'row', 
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }}
            >
                <div 
                    id={"chapter-sample-" + chapterDetails.id} 
                    className="chapter-sample-expanded"
                >
                    <div className="chapter-sample-header-container">
                        <div className="chapter-sample-header-container-left">
                            <img src={paragraph_icon} className="chapter-sample-paragraph-icon"/>
                            <div className="chapter-sample-title-container">
                                <h3 className='chapter-expanded-sample-title'>{chapterDetails.title}</h3>
                                <p className='chapter-expanded-sample-subtitle'>{chapterDetails.subtitle}</p>
                            </div>
                        </div>
                        <div className="chapter-sample-stats-container-container">
                                <div className="stats header">
                                    <img src={word_count_icon} className="chapter-sample-book-icon"/>
                                    {chapterDetails.wordCount}
                                </div>
                                <div className="stats interview header">
                                    <img src={microphone_icon} className="chapter-sample-book-icon"/>
                                    {chapterDetails.interviewLength}
                                </div>
                        </div>
                        <div className="chapter-sample-expanded-mobile-mockup-image-container">
                            <img src={mockup_img} className="chapter-sample-expanded-mobile-mockup-image" />
                        </div>
                    </div>
                    <div className="chapter-sample-expanded-pdf-preview">
                        {/* Desktop PDF viewer */}
                        <div className="desktop-pdf-viewer">
                            <iframe
                                src={`${pdf_url}#view=FitH&toolbar=0`}
                                width="100%"
                                height="100%"
                                title={`Chapter ${chapterDetails.id} PDF`}
                                className="pdf-iframe"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen={true}
                            ></iframe>
                        </div>
                        
                        {/* Mobile PDF alternative - image previews */}
                        <div className="mobile-pdf-preview">
                            <img 
                                src={chapter_image_preview} 
                                alt={`Preview of Chapter ${chapterDetails.id}`}
                                className="pdf-preview-image"
                            />
                            <a 
                                href={pdf_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="pdf-download-button"
                            >
                                View Full PDF
                            </a>
                        </div>
                        
                        
                        <div 
                            className="listen-button-area"
                            onClick={() => setAudioPlayerForChapterOpen(chapterDetails.id)}
                        >
                            <span className="listen-button-text">Listen</span>
                            <img src={listen_icon} className="listen-button-icon"/>
                        </div>
                    </div>
                </div>
                <div className="mockup-image-wrapper">
                    <img 
                        src={mockup_img} 
                        className="chapter-sample-expanded-mockup-image"
                    />
                </div>
            </motion.div>
        )
        
        const nonExpandedElem = (
            <motion.div 
                key="collapsed"
                initial={{ opacity: 0, scaleX: 0.5, scaleY: 0.8 }}
                animate={{ opacity: 1,  scaleX: 1, scaleY: 1, transition: { duration: 0 } }}
                exit={{ opacity: 0, scaleX: 0.5, scaleY: 0.8, transition: { duration: 0 }}}
                transition={{ duration: 0.4 }}
                style={{
                    transformOrigin: 'top left', 
                    display: 'flex', 
                    flexDirection: 'row',
                }}
            >
                <div id={"chapter-sample-" + chapterDetails.id} className="chapter-sample">
                    <div className="chapter-sample-text-container">
                        <div>
                            <div className="chapter-sample-header-container">
                                <img src={paragraph_icon} className="chapter-sample-paragraph-icon"/>
                                <div className="chapter-sample-title-container">
                                    <h3 className='chapter-sample-title'>{chapterDetails.title}</h3>
                                    <p className='chapter-sample-subtitle'>{chapterDetails.subtitle}</p>
                                </div>
                            </div>
                        </div>
                        <div className="chapter-sample-stats-container-container">
                            <div className="stats">
                                <img src={word_count_icon} className="chapter-sample-book-icon"/>
                                {chapterDetails.wordCount}
                            </div>
                        </div>
                    </div>
                    <div className="chapter-sample-collapsed-mockup-image-container">
                        <img src={mockup_img} className="chapter-sample-collapsed-mockup-image" />
                    </div>
                </div>
            </motion.div>
        )
        
        return (
            <div 
                key={chapterDetails.id} 
                className="chapter-sample-container"
            >
                <AnimatePresence initial={false} mode="wait">
                    {isExpanded ? expandedElem : nonExpandedElem}
                </AnimatePresence>
            </div>
        )
    }
    return (
        <div id={props.id}>
            <div className="line-container">
                <span className="horizontal-line line-left"></span>
                <div className="pill-box">
                    What could my story look like?
                </div>
                <span className="horizontal-line line-right"></span>
            </div>
            <h1 className="samples-title">Take a look at some samples</h1>
            <h2 className="samples-subtitle">Each chapter we create comes with both a written and audio version. Take a look—or a listen—below.</h2>
            <div className="chapter-samples-container">    
                {chapters.map((chapter, index) => getSampleChapter(chapter, index === expandedChapterIndex))}
                {audioPlayerForChapterOpen !== -1 && 
                    <AudioPlayer 
                        chapterId={audioPlayerForChapterOpen} 
                        chapterTitle={chapters[audioPlayerForChapterOpen - 1].subtitle}
                        onClose={() => setAudioPlayerForChapterOpen(-1)}
                    />
                }
            </div>
            <img src={arrow} className="main-intro-yellow-arrow" />
        </div>
    )
}